import { Content } from '../../types';

export const kohPhiPhiContent: Content = {
  title: 'קו פי פי Koh Phi Phi',
  imageUrl: '/images/thailand/koh-phi-phi/koh-phi-phi-wide.jpeg',
  introduction:
    'קבוצת האיים קו פי פי, הינה אחת מהפנינים היפות של תאילנד, הממוקמת בים אנדמן, בין האי פוקט ליבשת ומשתייכת מנהלתית למחוז קראבי. האיים ידועים ביופיים עוצר הנשימה, במימי הטורקיז הצלולים, בצוקי הגיר הדרמטיים ובחופים המרהיבים שמושכים תיירים מכל רחבי העולם.',
  sections: [
    {
      title: 'האיים המרכזיים',
      type: 'sub-headers',
      description:
        'קבוצת האיים פי פי כוללת מספר איים, כאשר שני האיים העיקריים הם:',
      content: [
        {
          subtitle: 'פי פי דון (Phi Phi Don)',
          text: 'האי הגדול והמאוכלס ביותר בקבוצה, פי פי דון, הינו המרכז התיירותי של האזור. כאן תמצאו את רוב אפשרויות הלינה - החל מגסטהאוסים פשוטים ועד ריזורטים יוקרתיים. האי מציע מסעדות מגוונות, חנויות, חיי לילה תוססים, וספורט ימי כצלילה, שנורקלינג, שיט קיאקים וסיורי סירות.\n\nהחוף המרכזי של האי הוא חוף טונסאי (Tonsai Beach), המשמש כנקודת ההגעה המרכזית של המעבורות והסירות המהירות מפוקט ומקראבי. בנוסף, חוף לו דאלום (Loh Dalum) מציע מים שקטים ורדודים ואווירה תוססת עם מסיבות חוף שמושכות מטיילים רבים.\n\nאחת האטרקציות המרכזיות באי הינה נקודת התצפית (Phi Phi Viewpoint), ממנה נשקף נוף פנורמי מרהיב של האי והים שמסביב. העלייה אורכת כ-40 דקות וכוללת מדרגות תלולות, אך התגמול בהתאם - נוף עוצר נשימה, במיוחד בשעת השקיעה!',
        },
        {
          subtitle: 'פי פי לה (Phi Phi Leh)',
          text: 'פי פי לה הוא האי השני בגודלו בקבוצת האיים והוא אינו מיושב. האי מפורסם בעיקר בזכות מפרץ מאיה (Maya Bay), שהתפרסם בעקבות הסרט "החוף" בכיכובו של לאונרדו דיקפריו. המפרץ מוקף בצוקים גבוהים ומים צלולים, מה שהופך אותו ליעד חובה לכל מבקר בקו פי פי. לאחר תקופה ארוכה של סגירה לצורך שיקום שונית האלמוגים, המפרץ נפתח מחדש עם הגבלות לשמירה על הסביבה.\n\nאטרקציות נוספות בפי פי לה כוללות את לגונת פילה (Pileh Lagoon), לגונה עוצרת נשימה עם מים בצבע טורקיז מוקפת בצוקים גבוהים ואת מערת ויקינג (Viking Cave), המכילה ציורי קיר עתיקים ונחשבת לאתר חשוב לליקוט קיני ציפורי סלה.',
        },
      ],
    },
    {
      title: 'סיורים מומלצים',
      type: 'sub-headers',
      description:
        'מהאי פי פי דון ניתן לצאת למגוון סיורים ימיים הכוללים ביקורים באתרים מדהימים:',
      content: [
        {
          subtitle: 'טיול שבעת האיים',
          text: 'אחד הסיורים הפופולריים ביותר באזור, המאפשר לחקור את האיים והמפרצים היפים ביותר במרחב:',
        },
        {
          subtitle: 'מפרץ הקופים (Monkey Bay)',
          text: 'מקום מצוין לשנורקלינג ולמפגש עם קופים החיים על הצוקים.',
        },
        {
          subtitle: 'מערת פאיה נאק (Phaya Naak Cave)',
          text: 'מערה ייחודית עם תצורות סלע מרשימות.',
        },
        {
          subtitle: 'לגונת פילה (Pileh Lagoon)',
          text: 'אחת הנקודות היפות ביותר באזור.',
        },
        {
          subtitle: 'לו סאמה (Loh Samah Bay)',
          text: 'מקום מעולה לצלילה ושנורקלינג.',
        },
        {
          subtitle: 'מפרץ מאיה (Maya Bay)',
          text: 'יעד חובה, כאמור, לכל מבקר באזור.',
        },
      ],
    },
    {
      title: 'דרכי הגעה',
      type: 'sub-headers',
      description: 'ישנן מספר דרכים להגיע לקו פי פי:',
      content: [
        {
          subtitle: 'מעבורות',
          text: 'אופציה זולה ונוחה יותר, מפוקט או מקראבי.',
        },
        {
          subtitle: 'סירות מהירות',
          text: 'מאפשרות הגעה מהירה וגמישה יותר, במיוחד עבור אלו שהמחפשים טיול יום מהאזורים הסמוכים.',
        },
      ],
      is12GoBanner: true,
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, קו פי פי הינו יעד חלומי המתאים לכל סוגי המטיילים - מחובבי מסיבות וחיי לילה, דרך חובבי טבע ונופים עוצרי נשימה ועד לאלו המחפשים חופשה רגועה על חופים לבנים ורכים. עם שילוב של מים צלולים, צוקים דרמטיים ואווירה ייחודית, האיים האלו מציעים חוויית טיול בלתי נשכחת.',
    },
  ],
};
